<template>
    <div class="pt-2 px-4">
        <div class="bg-lightest radius-normal border-light d-flex my-4 px-3">
            <div class="col-sm-12 pt-3" v-if="hasExtras">
                <div class="w-100 darker font-weight-600">Extras</div>

                <extra-selector :reservation="reservation"></extra-selector>
            </div>

            <div class="text-center dark fs-largest pt-5 text-center mb-4 w-100" v-else>
                This event has no extras
            </div>
        </div>
    </div>
</template>

<script>
    import ExtraSelector from './AddExtra/ExtraSelector'

    export default {
        data() {
            return {}
        },
        props:{
            reservation: {
                type: Object
            }
        },
        computed: {
            hasExtras() {
                return this.extrasArray && this.extrasArray.length > 0 && this.extrasArray.some(e => e.component.componentType === 0);
            },
            extrasArray() {
                if (this.reservation.event.eventComponents.length > 0) {
                    return this.reservation.event.eventComponents;
                } else if (this.reservation.event.product.extras.length > 0) {
                    return this.reservation.event.product.extras;
                } else {
                    return null;
                }
            },
        },
        components: {
            ExtraSelector
        }
    }
</script>

<style lang="scss" scoped>
    .extraNameWidth {
        width: 40%;
    }

    .addRemoveWidth {
        width: 10%;
    }

    .extraRow {
        height: 3rem;
    }
</style>



// WEBPACK FOOTER //
// AddExtra.vue?4c93d61e